/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Save model</h4>
<p>Save a copy of your model in the Phi format.</p>
<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcut:</b></li>
    <li class='shortcuts__item'><b>Ctrl-S</b>: Save model</li>
</ul>`;

export default function DownloadTooltip() {
    return h('div', { innerHTML: body });
}
